import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';
import { removeTestPoint } from './UserFunctions';
import PopupModal from './PopupModal';
import { deleteTestTableData } from '../actions/scenarioTestTableAction';
import PropTypes from 'prop-types';

class DeleteTestTableModal extends Component {
    constructor(props){
        super(props)
        this.state = {
            data: undefined,
            togglePopup: false,
            popUpText: undefined
        }
        this.handleDeleteContent = this.handleDeleteContent.bind(this);
        this.closePopupModal = this.closePopupModal.bind(this);
    }

    handleDeleteContent() {
        removeTestPoint( this.state.data, `${window.location.origin}/delete_test_point` ).then( (response) => {
            if(response && response.status === 200) {
                console.log("handle Delete")
                console.log(this.state.data.test_point_id)
                this.props.dispatch(deleteTestTableData(this.state.data.test_point_id))
                this.setState( (prevState) =>  {
                    return {
                        ...prevState,
                        togglePopup: true,
                        popUpText: response.data.status_message
                    }
                })
            }
        })
    }

    closePopupModal() {
        this.setState( (prevState) => {
            return {
                ...prevState,
                togglePopup: false
            }
        })
        this.props.handleCloseDeleteModal();
        const current = window.location.pathname;
        this.props.useHistory.history.replace(`/welcome`);
        setTimeout(() => {
          this.props.useHistory.history.replace(current);
        });
    }

    componentDidMount() {
        console.log('this.props.deleteContent')
        this.setState( (prevState) => {
            return {
                ...prevState,
                data: this.props.deleteContent
            }
        })
    }

    render() {
        return (
            <div>
                <Modal isOpen={this.props.deleteSelectedRow >=0}>
                    <ModalHeader
                        toggle={this.props.handleCloseDeleteModal}
                        style={{ color:"#524fa1" }}
                    >
                        Delete Test Point
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            Are you sure want to delete ?
                        </div>
                    </ModalBody>
                    <ModalFooter>
                      <Button className="btn" style={{ backgroundColor: "red" }} onClick={this.handleDeleteContent}>Delete</Button>
                      <Button className="btn" onClick={this.props.handleCloseDeleteModal}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                {this.state.togglePopup ? <PopupModal text={this.state.popUpText} closePopup={this.closePopupModal} /> : undefined}
            </div>
        )
    }
}
DeleteTestTableModal.propTypes={
dispatch:PropTypes.string,
handleCloseDeleteModal:PropTypes.string,
useHistory:PropTypes.string,
deleteContent:PropTypes.string,
deleteSelectedRow:PropTypes.string,
}
DeleteTestTableModal.defaultProps= {
dispatch:[],
handleCloseDeleteModal:[],
useHistory:[],
deleteContent:[],
deleteSelectedRow:[],
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

export default connect()(DeleteTestTableModal);
